module.exports = __webpack_public_path__ + "static/media/15_pol_0_84.54.f3a8b58b.png";